import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Location } from '@angular/common';

import { ModalComponent } from '../../modal/modal.component';
import { AssistancePluginService } from './assistance-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';

@Component({
  selector: 'assistance-edit',
  templateUrl: './assistance-edit.component.html',
  standalone: false
})
export class AssistanceEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  plugin: any;
  editForm: UntypedFormGroup;
  actionOptions: any[];
  public currentItem: any;
  public processing = false;
  private assistanceToRemove: number;
  private currentControlName: string;
  private currentAssistanceIndex: number;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;
  @ViewChild('assistanceDeleteConfirm', { static: true }) assistanceDeleteConfirm: ConfirmComponent;
  @ViewChild('actionModal', { static: true }) actionModal: ModalComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: AssistancePluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateAssistances(this.inspectionId, this.pointId, this.pluginId, model.assistances).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.actionOptions = this.service.getActionOptions();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['assistances'];
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['assistances'];
    control.push(this.initAssistance());
  }

  initForm() {
    this.editForm = this.fb.group({
      assistances: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['assistances'];
    _.forEach(this.plugin.config.Assistances, (el) => {
      control.push(this.initAssistance(el));
    });
  }

  initAssistance(el?: any) {
    return this.fb.group({
      During: new UntypedFormControl(el && el.During ? el.During : ''),
      Action: new UntypedFormControl(el && el.Action != null ? el.Action : null),
      Comment: new UntypedFormControl(el && el.Comment ? el.Comment : '')
    });
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['assistances'];
    control.removeAt(this.assistanceToRemove);
  }

  public openActionSelector(index: number) {
    this.currentAssistanceIndex = index;
    const control = (<UntypedFormArray>this.editForm.controls['assistances']).at(index).get('Action');
    this.openSelector(this.actionModal, this.actionOptions, control.value);
  }

  public selectActionMenu(item: any) {
    const control = (<UntypedFormArray>this.editForm.controls['assistances']).at(this.currentAssistanceIndex).get('Action');
    const selectedIndex = control.value === item.selectedIndex ? null : item.selectedIndex;
    control.setValue(selectedIndex);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openAssistanceDeleteConfirm(i: number) {
    this.assistanceDeleteConfirm.open();
    this.assistanceToRemove = i;
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
